import Vue from 'vue/dist/vue.esm';
import * as uiv from 'uiv';
import { I18nModule } from './i18n';

import ExampleComponent from '../components/ExampleComponent.vue';
import DatePickerComponent from '../components/DatePicker.vue';

export class VueModule {

  /**
   * Définir les composantes VueJS ICI.
   */
  static components = {
    'example-component': ExampleComponent,
    'date-picker': DatePickerComponent
  }

  /**
   * Initialise le module VueJS
   */
  static init() {

    Vue.use(uiv);

    for (const name in VueModule.components) {
        const component = VueModule.components[name];
        Vue.component(name, component);
    }
    
    Vue.mixin({
      methods: {
        L: (key, placeholders) => I18nModule.translate(key, placeholders),
        __: (key, placeholders) => I18nModule.translate(key, placeholders)
      }
    })
    
  }

  /**
   * Rafraîchi les composantes VueJS dans le document.
   * @param {string} selector Sélecteur.
   */
  static refreshInDocument(selector) {

    if(selector === undefined) selector = "body";

    document.querySelectorAll(selector).forEach(el => {
      el.querySelectorAll(".vue-enabled").forEach(el2 => {
        var vm = new Vue({
          el: el2
        });
      })
    });

  }

}

window.refreshVue = (selector) => VueModule.refreshInDocument(selector);

window.onload = function(){
  VueModule.refreshInDocument();
}